import React, { useState } from "react";
import {
  ActivityIndicator,
  Pressable,
  StyleSheet,
  Text,
  View,
} from "react-native";

interface ButtonProps {
  onPress: () => void;
  label: string;
  variant: "filled" | "outlined";
  isDisabled?: boolean;
  isLoading?: boolean;
}

const ActionButton = ({
  onPress,
  label,
  variant,
  isDisabled = false,
  isLoading = false,
}: ButtonProps): React.JSX.Element => {
  const [isPressed, setIsPressed] = useState<boolean>(false);

  const handlePressIn = (): void => {
    setIsPressed(true);
    //Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
  };

  const handlePressOut = (): void => {
    setIsPressed(false);
  };

  return (
    <Pressable
      disabled={isDisabled || isLoading}
      onPress={onPress}
      onPressIn={handlePressIn}
      onPressOut={handlePressOut}
      style={({ pressed }) => [
        styles.buttonContainer,
        variant === "filled" ? styles.filledButton : styles.outlinedButton,
        pressed && styles.buttonPressed,
        isDisabled && { opacity: 0.5 },
      ]}
    >
      <Text
        style={[
          styles.buttonText,
          variant === "filled"
            ? styles.filledButtonText
            : styles.outlinedButtonText,
          isPressed && styles.buttonTextPressed,
        ]}
      >
        {label}
      </Text>
      <View style={styles.indicatorContainer}>
        {isLoading && (
          <ActivityIndicator
            size="small"
            color={variant === "filled" ? "#FFFFFF" : "#A757FF"}
          />
        )}
      </View>
    </Pressable>
  );
};

export default ActionButton;

const styles = StyleSheet.create({
  buttonContainer: {
    height: 56,
    borderRadius: 28,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  indicatorContainer: {
    position: "absolute",
    right: 24,
  },
  filledButton: {
    backgroundColor: "#4299E1",
  },
  outlinedButton: {
    backgroundColor: "transparent",
    borderWidth: 1,
    borderColor: "#A757FF",
  },
  buttonPressed: {
    transform: [{ scale: 0.98 }],
    opacity: 0.9,
  },
  buttonText: {
    fontSize: 18,
    fontWeight: "600",
  },
  filledButtonText: {
    color: "#FFFFFF",
  },
  outlinedButtonText: {
    color: "#A757FF",
  },
  buttonTextPressed: {
    opacity: 0.8,
  },
});
